var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-va",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M256 0h256v512H256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M282.4-735.1c0 .6 56 222.8 118.2 300.5 69.4 87.3 113.2 87.4 113.2 87.4l70.9-17.8s-41.6 2.1-123.9-104.2c-83.4-107.7-109.4-286-108.1-282.8l-70.3 16.9z",
    transform: "matrix(-.21542 0 0 .17871 450.5 340.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M285-727.6c-1.5-9.4 33.9 221 140.2 327.2 53.1 53.1 88.6 53.1 88.6 53.1l88.6-17.7s-51.7 3.8-134-102.5c-83.5-107.8-108.6-263.3-108-263.9l-75.4 3.8z",
    transform: "matrix(.21542 0 0 .17871 313.9 342.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M282.4-735.1c0 .6 56 222.8 118.2 300.5 69.4 87.3 113.2 87.4 113.2 87.4l70.9-17.8s-41.6 2.1-123.9-104.2c-83.4-107.7-109.4-286-108.1-282.8l-70.3 16.9z",
    transform: "matrix(.21542 0 0 .17871 313.9 342.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M285-727.6c-1.5-9.4 33.9 221 140.2 327.2 53.1 53.1 88.6 53.1 88.6 53.1l88.6-17.7s-51.7 3.8-134-102.5c-83.5-107.8-108.6-263.3-108-263.9l-75.4 3.8z",
    transform: "matrix(-.21542 0 0 .17871 450.5 340.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m344.5-596.3 9.2 22.1s1.5-9.7 8.5-11.5l7-1.7s27 49.3 32.3 58.1c5.3 8.8-3.6 16.8-1.8 16.8s26.5-11.5 26.5-11.5-10.6.9-15-6.2-34.8-60-34.8-60 6.1-2.6 11.4-5.2c5.3-2.7 10.6 8 10.6 8L385.2-614s0 8.9-4.4 10.6c-4.4 1.8-8 3.6-8 3.6s-3.5-6.2-8-13.3c-4.4-7 4.5-14.1 4.5-14.1l-23 11.5s8 4.4 10.6 8.8l5.3 8.8s-3.2 1.8-8.2 3.5c-3.6 1.9-7.7 0-9.5-1.7z",
    transform: "matrix(.21538 .00384 -.00463 .17867 312.2 347.8)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#b00",
    stroke: "#000",
    strokeWidth: 14.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01583 .00247 .00912 -.01043 340 336.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01553 .00281 .0093 -.0104 338.6 337.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01583 .00247 .00912 -.01043 336.7 339.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01606 -.001 .00564 -.01204 356.6 321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01588 -.00034 .0061 -.01195 355.6 322.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01608 -.00073 .00592 -.01194 354.2 324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01587 .0005 .007 -.0116 353.3 324.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01584 -.00241 .00408 -.01247 360.6 315.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.0157 -.002 .00426 -.0125 359.7 316.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01584 -.00241 .00408 -.01247 358.5 318.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01575 -.00175 .00455 -.01242 357.5 320)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01601 .0014 .00808 -.01102 346.2 331.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01575 .00175 .00826 -.011 344.9 332.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01601 .0014 .00808 -.01102 343.1 334.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01553 .00281 .0093 -.0104 341.9 335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.0161 .00013 .00681 -.0116 351.7 326.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01587 .0005 .007 -.0116 350.5 327.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01601 .0014 .00808 -.01102 349.3 328.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01575 .00175 .00826 -.011 348 329.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01497 -.00495 .0011 -.0129 369.3 295.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01532 -.00352 .0025 -.01283 369.3 296.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.0154 -.00394 .00232 -.01278 368.4 298.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01532 -.00352 .0025 -.01283 367.8 299.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01493 -.00453 .00126 -.01295 371.1 290)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01497 -.00495 .0011 -.0129 370.5 292)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01493 -.00453 .00126 -.01295 370 293.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01572 -.0029 .00353 -.01259 364.3 308.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.0156 -.00249 .0037 -.01262 363.5 310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01572 -.0029 .00353 -.01259 362.4 311.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.0157 -.002 .00426 -.0125 361.7 313.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.0154 -.00394 .00232 -.01278 366.9 301.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.0156 -.00249 .0037 -.01262 367.2 302.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01572 -.0029 .00353 -.01259 366.1 304.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.0156 -.00249 .0037 -.01262 365.3 306.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01384 -.0069 -.00138 -.01288 374 279.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01486 -.00518 .00082 -.01291 374 281.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01483 -.00476 .00099 -.01297 373.6 282.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01388 -.00647 -.00122 -.01295 374.7 273.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01384 -.0069 -.00138 -.01288 374.4 276)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01388 -.00647 -.00122 -.01295 374.3 277.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01486 -.00518 .00082 -.01291 373 285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01493 -.00453 .00126 -.01295 372.4 286.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01497 -.00495 .0011 -.0129 371.7 288.2)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#b00",
    stroke: "#000",
    strokeWidth: 14.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01599 .0016 -.00828 -.01091 422.7 331.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01571 .00195 -.00846 -.0109 424.1 332.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01599 .0016 -.00828 -.01091 425.9 334.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01594 -.00187 -.00468 -.01232 407.4 315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01582 -.00121 -.00515 -.01226 408.3 316.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01598 -.0016 -.00497 -.01224 409.6 318.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01588 -.00037 -.00607 -.01196 410.4 318.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01562 -.00328 -.0031 -.01267 403.9 309)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01551 -.00286 -.00327 -.0127 404.7 310.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01562 -.00328 -.0031 -.01267 405.6 312.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01558 -.0026 -.00357 -.01265 406.6 314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01609 .0005 -.0072 -.01144 417 326)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01585 .00088 -.00738 -.01143 418.2 327.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01609 .0005 -.0072 -.01144 419.8 329)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01571 .00195 -.00846 -.0109 421 329.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01607 -.00076 -.00589 -.01195 411.8 320.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01588 -.00037 -.00607 -.01196 413 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01609 .0005 -.0072 -.01144 414 323)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01585 .00088 -.00738 -.01143 415.3 324.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01455 -.00577 -.00008 -.01293 396.7 289.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.015 -.00436 -.00148 -.01293 396.7 289.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01505 -.00478 -.00131 -.01288 397.4 291.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.015 -.00436 -.00148 -.01293 398 293.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01455 -.00534 -.00025 -.013 395.3 283.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01455 -.00577 -.00008 -.01293 395.8 285.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01455 -.00534 -.00025 -.013 396.2 287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01546 -.00376 -.00253 -.01275 400.7 302)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01538 -.00334 -.0027 -.0128 401.4 303.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01546 -.00376 -.00253 -.01275 402.3 305.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01551 -.00286 -.00327 -.0127 403 307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01505 -.00478 -.00131 -.01288 398.6 295.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01538 -.00334 -.0027 -.0128 398.2 296.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01546 -.00376 -.00253 -.01275 399.1 298.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01538 -.00334 -.0027 -.0128 399.8 300)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01327 -.00764 .00239 -.01277 393.3 273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01443 -.00598 .0002 -.01293 393.1 274.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01443 -.00556 .00003 -.013 393.5 276)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01334 -.00722 .00224 -.01286 393 267)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01327 -.00764 .00239 -.01277 393.1 269.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01334 -.00722 .00224 -.01286 393.2 270.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01443 -.00598 .0002 -.01293 394 278.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01455 -.00534 -.00025 -.013 394.4 279.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01455 -.00577 -.00008 -.01293 395 281.5)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m344.5-596.3 9.2 22.1s1.5-9.7 8.5-11.5l7-1.7s27 49.3 32.3 58.1c5.3 8.8-3.6 16.8-1.8 16.8s26.5-11.5 26.5-11.5-10.6.9-15-6.2-34.8-60-34.8-60 6.1-2.6 11.4-5.2c5.3-2.7 10.6 8 10.6 8L385.2-614s0 8.9-4.4 10.6c-4.4 1.8-8 3.6-8 3.6s-3.5-6.2-8-13.3c-4.4-7 4.5-14.1 4.5-14.1l-23 11.5s8 4.4 10.6 8.8l5.3 8.8s-3.2 1.8-8.2 3.5c-3.6 1.9-7.7 0-9.5-1.7z",
    transform: "matrix(-.21538 .00384 .00463 .17867 452.2 346.2)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.12959 0 0 .10848 351.4 305.6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    d: "m324.6-255.4-50.2 50.1L449.8-29.9l50.1-50z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.3,
    cy: -1428,
    r: 35.4,
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    transform: "scale(-1 1) rotate(45 -177.9 -1104.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m-402-957 37.5 37.7-25 25-37.6-37.6c-12.5-12.5 12.5-37.5 25-25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m-346.6-926.5-50.1 50a25 25 0 0 1-25-25c10.8-25.8 25-38.4 50-50a26.9 26.9 0 0 1 25 25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m-352-931.9 37.7 37.6-50.2 50.1-37.5-37.5c5-20 30-45.1 50-50.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m-309-889-50.1 50.1a25.1 25.1 0 0 1-25-25c10.8-25.9 25-38.4 50-50.1a26.9 26.9 0 0 1 25 25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M-314.4-894.3 28.4-551.5l-50 50.1-342.9-342.8c5-20 30.1-45 50.1-50z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m49-531-50.2 50.1a25.1 25.1 0 0 1-25-25c10.8-25.9 25-38.5 50-50.1A26.9 26.9 0 0 1 49-531z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m49-531 225.4 225.5-50 50.1L-1.3-480.9c5-20 30.1-45 50.1-50z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m186.7-418.2-75.1 75.1a25.1 25.1 0 0 1-25-25s0-25 25-50.1 50-25 50-25c11.7 1.5 21.5 12.4 25.1 25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m186.7-418.2 50.2 75.1-50.1 50.1-75.2-50c-2.8-2.5 0-25.1 25-50.2s49-24.4 50.1-25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M336.6-506.7c0-35.4 0-86.6 17.7-130C372-593.3 372-542 372-506.7h-35.4z",
    transform: "rotate(135 434.8 18.7) scale(1 -.81782)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M318.9-506.7h17.7V-550c0-43.3-35.4-65-35.4-65l17.7 108.3z",
    transform: "rotate(-45 399.4 -194.2) scale(1 .81782)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M318.9-506.7h17.7V-550c0-43.3-35.4-65-35.4-65l17.7 108.3z",
    transform: "rotate(135 434.8 18.7) scale(1 -.81782)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m-314.4-894.3 37.6 37.6c25 25 112.8 137.8 112.8 137.8s117.3 92.3 142.3 117.3L16-564c-25-25-180-129.8-180-129.8S-71.7-551.5-34.1-514l-37.6-37.6c-25-25-117.3-142.3-117.3-142.3S-289.3-769-314.4-794.1l-50-50c25 25 175.3 125.2 175.3 125.2s-100.2-150.3-125.3-175.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M299.5-230.3A907.4 907.4 0 0 0 412.2-92.5a83 83 0 0 0 50.1 25s0-25-25-50a899 899 0 0 0-137.8-112.8zm-62.6-112.8c87.6 87.7 187.9 137.8 250.5 200.5 50.1 50 15.4 88.4 1.4 100.6-14 12.1-52 50.3-101.6-.4C324.5-105 274.4-205.3 186.7-293c0-25 25.1-50 50.1-50z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M218.3 257.9h23v73h-23z",
    transform: "matrix(-1.2487 -1.4214 -1.3593 1.3175 1166.1 -102.6)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "silver",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.6,
    d: "m301.2 396.9 17.7 17.7-17.7 17.7 8.8 8.8 17.7-17.7 35.5 35.5-17.7 17.7 8.8 8.8 17.7-17.7 17.8 17.7-53.2 53.2-35.4-35.4 17.7-17.8 8.9 8.9 8.8-8.9-35.4-35.4-8.9 8.9 8.9 8.8-17.7 17.7-17.7-17.7 8.8-8.8-8.8-8.9-35.5 35.4 8.9 8.9 8.8-8.9 17.8 17.8-17.8 17.7-8.8-8.9-8.9 8.9 35.5 35.4 8.8-8.9-8.8-8.8 17.7-17.7 35.4 35.4-53.1 53.1-17.8-17.7 17.8-17.7-9-8.8-17.6 17.7-35.5-35.5 17.8-17.7-8.9-8.8-17.7 17.7-17.7-17.7 124-124z",
    transform: "matrix(-2.2946 0 0 2.2438 360.6 -1733.7)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M318.9 786.6V822l88.6 88.6v-70.8L389.8 822h-35.5L319 786.6z",
    transform: "matrix(-1.1473 0 0 1.1219 157.3 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m230.4 698.8 70.4 70.4.8 35.2-71.2-71.3v-34.3z",
    transform: "matrix(-1.1473 0 0 1.1219 157.4 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m301.2 804.3 35.4-35.4v-35.4l-35.4 35.4v35.4z",
    transform: "matrix(-1.1473 0 0 1.1219 157.3 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m301.2 804.3 35.4-35.4v-35.4l-35.4 35.4v35.4z",
    transform: "matrix(-1.1473 0 0 1.1219 259 -1387.9)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M248 644.9v35.4l17.8-17.7-17.8-17.7z",
    transform: "matrix(-1.1473 0 0 1.1219 157.3 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M248 644.9v35.4l17.8-17.7-17.8-17.7z",
    transform: "matrix(-1.1473 0 0 1.1219 55.7 -1189.1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m230.4 698.8 35.8 35.4v35.4l-35.8-36.5v-34.3z",
    transform: "matrix(-1.1473 0 0 1.1219 218.8 -1349)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m301.2 804.3 35.4-35.4v-35.4l-35.4 35.4v35.4z",
    transform: "matrix(-1.1473 0 0 1.1219 55.7 -1507.1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m301.2 804.3 35.4-35.4v-35.4l-35.4 35.4v35.4z",
    transform: "matrix(-1.1473 0 0 1.1219 137 -1427.6)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m283.5 822 53.1-53.1v-35.4l-70.9 70.8 17.8 17.8z",
    transform: "matrix(-1.1473 0 0 1.1219 137 -1546.9)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M248 644.9v35.4l17.8-17.7-17.8-17.7z",
    transform: "matrix(-1.1473 0 0 1.1219 35.4 -1447.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M301.2 804.3 265.8 769v-35.4l35.4 35.4v35.4z",
    transform: "matrix(-1.1473 0 0 1.1219 55.7 -1507.1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m389.8 822-53.2-53v-35.4l70.9 70.8-17.7 17.8z",
    transform: "matrix(-1.1473 0 0 1.1219 55.7 -1546.9)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m230.4 698 70.9 71h35.4l17.7 17.6v70.9l-124-124.4v-35z",
    transform: "matrix(-1.1473 0 0 1.1219 -66.2 -1387.9)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m354.3 822 106.3-106.3h35.5L389.8 822h-35.5zm53.2 17.8 106.3-106.3-17.7-17.7L389.8 822l17.7 17.7z",
    transform: "matrix(-1.1473 0 0 1.1219 157.3 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M407.5 839.8v70.8l106.3-106.3v-70.8L407.5 839.8z",
    transform: "matrix(-1.1473 0 0 1.1219 157.3 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m354.3 822 106.3-106.3h35.5L389.8 822h-35.5zm53.2 17.8 106.3-106.3-17.7-17.7L389.8 822l17.7 17.7z",
    transform: "matrix(-1.1473 0 0 1.1219 -5.3 -1447.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M407.5 839.8v70.8l106.3-106.3v-70.8L407.5 839.8z",
    transform: "matrix(-1.1473 0 0 1.1219 -5.3 -1447.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m318.9 786.6 17.7-17.7v-35.4l-35.4 35.4 17.7 17.7z",
    transform: "matrix(-1.1473 0 0 1.1219 -86.6 -1527)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m318.9 786.6 17.7-17.7v-35.4l-35.4 35.4 17.7 17.7z",
    transform: "matrix(-1.1473 0 0 1.1219 15 -1626.4)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M265.8 768.9v-35.4l17.7 17.7-17.7 17.7z",
    transform: "matrix(-1.1473 0 0 1.1219 55.7 -1348.1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M301.2 804.3 265.8 769l17.7-17.7 17.7 17.7v35.4z",
    transform: "matrix(-1.1473 0 0 1.1219 137 -1427.6)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m301.2 804.3-17.7-17.7 17.7-17.7v35.4z",
    transform: "matrix(-1.1473 0 0 1.1219 15 -1586.6)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M196.5 254.2h25.2v80.2h-25.2z",
    transform: "matrix(-1.2509 -1.4194 -1.3614 1.3153 1166.1 -102.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M336.6 166.5c0 14.7 35.4 35.5 35.4-17.7h-35.4v17.7z",
    transform: "matrix(-1.8992 0 0 1.8865 1166.1 -102.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M242.1 24.8c-147 0-113.1 164.2-100.4 124 9.4-29.5 35.5-70.8 65-80.2C246.9 55.8 233.4 78 248 78c14.7 0 1.2-22.2 41.4-9.4 29.5 9.4 55.6 50.7 65 80.2 12.7 40.3 53-124-112.3-124z",
    transform: "matrix(-1.8992 0 0 1.8865 1166.1 -102.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M389.8 166.5a141.8 141.8 0 0 1-283.5 0v-17.7c0-29 35.4 124 141.7 124s141.8-124.7 141.8-124v17.7z",
    transform: "matrix(-1.8992 0 0 1.8865 1166.1 -102.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M336.6 166.5c0 14.7 35.4 35.5 35.4-17.7h-35.4v17.7z",
    transform: "matrix(1.8992 0 0 1.8865 224 -100.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M389.8 148.8a141.8 141.8 0 1 1-283.6 0 141.8 141.8 0 0 1 283.6 0zm-53.2 0c0 14.7 22.8 3 9.4 43a81 81 0 0 1-56.6 55c-40.2 12.7-26.7-9.4-41.4-9.4-14.6 0-1.1 22.1-41.3 9.4a80.2 80.2 0 0 1-56.6-56.6c-12.8-40.2 9.3-26.7 9.3-41.4s-22-1.1-9.3-41.3a80.2 80.2 0 0 1 56.6-56.6c40.2-12.8 26.7 9.3 41.3 9.3 14.7 0 1.2-22 41.4-9.3a80.3 80.3 0 0 1 56.6 56.6c12.7 40.2-9.4 26.6-9.4 41.3z",
    transform: "matrix(-1.8992 0 0 1.8865 1166.1 -102.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M126.5 157.7c-20.2 0-1.9 67.6-9 51.7a126.5 126.5 0 0 1 0-103.4c7.1-16-11.2 51.7 9 51.7z",
    transform: "matrix(-1.6618 0 0 1.7607 1107.2 -99.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M372 140a88 88 0 0 1-9.7 44.8c-8 13.7 9.8-44.8-8-44.8 17.7 0 1.7-58.6 8-44.8a107.7 107.7 0 0 1 9.8 44.8z",
    transform: "matrix(-1.8992 0 0 2.0316 1166.1 -106.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M296.3 263a123.5 123.5 0 0 1-96.5 0c-14.9-6.2 48.2 9.8 48.2-7.9 0 17.7 63.1 1.7 48.3 8zM248 42.6c0-17.7-63-1.7-48.2-8a123 123 0 0 1 96.5 0c14.8 6.3-48.3-9.7-48.3 8z",
    transform: "matrix(-1.8992 0 0 1.8865 1166.1 -102.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.1,
    cy: 160.9,
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    rx: 18.4,
    ry: 20.1,
    transform: "matrix(-1.2929 -1.3819 -1.3912 1.2842 1257.6 -120)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M276.6 287.7a142 142 0 0 1-57.1 0l-1.5 7a149 149 0 0 0 60 0l-1.4-7z",
    transform: "matrix(-1.2929 -1.3819 1.3912 -1.2842 808.9 712)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M276.6 287.7a142 142 0 0 1-57.1 0l-1.5 7a149 149 0 0 0 60 0l-1.4-7z",
    transform: "matrix(-1.2929 -1.3819 -1.3912 1.2842 1223.2 329.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M267.7 308.5c-9.2 1.9-20.2 1-30 1-9.7 0-19.3-2.7-28.5-4.6l8.8-10.3a149.3 149.3 0 0 0 60 0l-10.3 14z",
    transform: "matrix(-1.2929 -1.3819 -1.3912 1.2842 1223.2 329.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M276.6 287.7a142 142 0 0 1-57.1 0l-1.5 7a149 149 0 0 0 60 0l-1.4-7z",
    transform: "matrix(-1.3912 1.2842 1.2929 1.3819 847.4 -345.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.1,
    cy: 160.9,
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    rx: 18.4,
    ry: 20.1,
    transform: "matrix(-1.2929 -1.3819 -1.3912 1.2842 789.1 314.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M267.6 281.5c-9.2 1.9-17.1 3-26.9 3s-23-.8-32.3-2.7l9.6 12.8a149.5 149.5 0 0 0 60 0l-10.4-13.1z",
    transform: "matrix(-1.3912 1.2842 1.2929 1.3819 850.6 -315.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m174 271.8-.9 14.8-3.2 4.5 1-15 3-4.3zm156.5-6.2 3.6 4.2 1 13.6-2.9-3-1.7-14.8z",
    transform: "matrix(-1.8992 0 0 1.8865 1166.1 -102.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.1,
    cy: 160.9,
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    rx: 18.4,
    ry: 20.1,
    transform: "matrix(-1.2929 -1.3819 -1.3912 1.2842 1237.6 329.9)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m513.8-790.2 35.4-17.7 35.4 17.7s-73.3 35.5-73.3 159.5c0 88.6 125.2 106.3 125.2 212.6 0 45.6-34.1 88.6-69.6 88.6s-88.6-17.7-141.7-70.9c35.4 17.7 76 37.3 106.3 36 19.6-.3 55-17.7 55-53 0-71-122.8-107-122.8-213.3 0-124 50-159.4 50-159.4z",
    transform: "matrix(-.21542 0 0 .17871 450.5 340.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m520.3-790.2 46.6-17.7 10 17.7s-70.6 35.5-70.6 159.5c0 88.6 125.9 106.3 125.9 212.6 0 45.6-26.7 87.4-65.3 88.6-73.4 2.3-90.4-24-141.7-70.9 43.1 32.3 105 46.8 129 34.2 29.4-15.4 35-36 35-53.8 0-70.9-120.9-104.4-120.9-210.7 0-124 52-159.4 52-159.4z",
    transform: "matrix(-.21542 0 0 .17871 450.5 340.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M513.3-789.7c7-2.4 36-18.2 71.3 17.3 17.8 17.7 17.8 53.1 17.8 70.8l53.1-53.1s-29-86.9-107.6-53.6a334.8 334.8 0 0 0-34.5 18.6z",
    transform: "matrix(-.21542 0 0 .17871 450.5 340.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M523.8-796c8.8-2.8 36.7-6.3 64.6 18.6 17.7 17.7 19 42.9 19 60.6l40.6-38c3.4-3.1-24.8-81.2-99.2-54a154 154 0 0 0-25 12.9z",
    transform: "matrix(-.21542 0 0 .17871 450.5 340.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m344.5-596.3 9.2 22.1s1.5-9.7 8.5-11.5l7-1.7s27 49.3 32.3 58.1c5.3 8.8-3.6 16.8-1.8 16.8s26.5-11.5 26.5-11.5-10.6.9-15-6.2-34.8-60-34.8-60 6.1-2.6 11.4-5.2c5.3-2.7 10.6 8 10.6 8L385.2-614s0 8.9-4.4 10.6c-4.4 1.8-8 3.6-8 3.6s-3.5-6.2-8-13.3c-4.4-7 4.5-14.1 4.5-14.1l-23 11.5s8 4.4 10.6 8.8l5.3 8.8s-3.2 1.8-8.2 3.5c-3.6 1.9-7.7 0-9.5-1.7z",
    transform: "matrix(-.17534 -.01853 -.05985 .15541 365.6 343.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m344.5-596.3 9.2 22.1s1.5-9.7 8.5-11.5l7-1.7s27 49.3 32.3 58.1c5.3 8.8-3.6 16.8-1.8 16.8s26.5-11.5 26.5-11.5-10.6.9-15-6.2-34.8-60-34.8-60 6.1-2.6 11.4-5.2c5.3-2.7 10.6 8 10.6 8L385.2-614s0 8.9-4.4 10.6c-4.4 1.8-8 3.6-8 3.6s-3.5-6.2-8-13.3c-4.4-7 4.5-14.1 4.5-14.1l-23 11.5s8 4.4 10.6 8.8l5.3 8.8s-3.2 1.8-8.2 3.5c-3.6 1.9-7.7 0-9.5-1.7z",
    transform: "matrix(.15954 .02165 .00278 -.11904 258.9 126)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.12959 0 0 .10848 351.4 305.6)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    transform: "rotate(45 478.1 -504.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 354.3,
    cy: -1428,
    r: 35.4,
    fill: "silver",
    stroke: "#000",
    transform: "translate(124 283.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    d: "M460.6-1126.8v53.2h35.5v-53.2c0-17.7-35.5-17.7-35.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    d: "M443-1066h70.8a25.1 25.1 0 0 0 0-35.5c-26-10.6-44.9-9.5-70.9 0a27 27 0 0 0 0 35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    d: "M443-1073.6v53.1h70.8v-53.1c-17.7-10.6-53.2-10.6-70.9 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    d: "M443-1013h70.8a25.1 25.1 0 0 0 0-35.4c-26-10.6-44.9-9.5-70.9 0a27 27 0 0 0 0 35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    d: "M443-117h70.8v248.1h-70.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    d: "M443-1020.5v484.8h70.8v-484.8c-17.7-10.6-53.2-10.6-70.9 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    d: "M443-506.7h70.8a25.1 25.1 0 0 0 0-35.4c-26-10.6-44.9-9.5-70.9 0a27 27 0 0 0 0 35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    d: "M443-506.7v318.9h70.8v-318.9c-17.7-10.6-53.2-10.6-70.9 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    d: "M425.2-329.5h106.3a25 25 0 0 0 0-35.5s-17.7-17.7-53.2-17.7-53.1 17.7-53.1 17.7c-7.1 9.4-6.3 24 0 35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    d: "m425.2-329.5 17.7 88.6h70.9l17.7-88.6c.3-3.8-17.7-17.7-53.2-17.7s-51.9 17.3-53.1 17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    d: "M336.6-506.7c0-35.4 0-86.6 17.7-130C372-593.3 372-542 372-506.7h-35.4z",
    transform: "matrix(1 0 0 .81782 124 173.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    d: "M318.9-506.7h17.7V-550c0-43.3-35.4-65-35.4-65l17.7 108.3z",
    transform: "matrix(-1 0 0 .81782 832.7 173.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    d: "M318.9-506.7h17.7V-550c0-43.3-35.4-65-35.4-65l17.7 108.3z",
    transform: "matrix(1 0 0 .81782 124 173.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    d: "M478.3-117a908.6 908.6 0 0 1 17.8 177.2 83 83 0 0 1-17.8 53.2s-17.7-17.7-17.7-53.2c0-17.7 0-88.6 17.7-177.1zM443-241c0 124-35.4 230.4-35.4 319 0 70.8 51.6 73.4 70 72.1 18.6-1.3 72.4-1.2 71.7-72.2 0-88.5-35.4-194.8-35.4-318.9-17.7-17.7-53.2-17.7-70.9 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    d: "M443-1020.5v53.2c0 35.4 17.6 177.1 17.6 177.1S443-642 443-606.6v53.2c0-35.4 35.4-219 35.4-219s35.5 165.9 35.5 219v-53.2c0-35.4-17.7-183.6-17.7-183.6s17.7-124 17.7-159.4v-70.9c0 35.4-35.4 212.6-35.4 212.6S443-985.1 443-1020.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M218.3 257.9h23v73h-23z",
    transform: "matrix(1.2487 -1.4214 1.3593 1.3175 -662.5 -102.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M336.6 166.5c0 14.7 35.4 35.5 35.4-17.7h-35.4v17.7z",
    transform: "matrix(1.8992 0 0 1.8865 -662.5 -102.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M242.1 24.8c-147 0-113.1 164.2-100.4 124 9.4-29.5 35.5-70.8 65-80.2C246.9 55.8 233.4 78 248 78c14.7 0 1.2-22.2 41.4-9.4 29.5 9.4 55.6 50.7 65 80.2 12.7 40.3 53-124-112.3-124z",
    transform: "matrix(1.8992 0 0 1.8865 -662.5 -102.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M389.8 166.5a141.8 141.8 0 0 1-283.5 0v-17.7c0-29 35.4 124 141.7 124s141.8-124.7 141.8-124v17.7z",
    transform: "matrix(1.8992 0 0 1.8865 -662.5 -102.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.1,
    cy: 160.9,
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    rx: 18.4,
    ry: 20.1,
    transform: "matrix(1.2929 -1.3819 1.3912 1.2842 -753.9 -120)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M196.5 254.2h25.2v80.2h-25.2z",
    transform: "matrix(1.2509 -1.4194 1.3614 1.3153 -662.5 -102.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M336.6 166.5c0 14.7 35.4 35.5 35.4-17.7h-35.4v17.7z",
    transform: "matrix(-1.8992 0 0 1.8865 279.7 -100.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M389.8 148.8a141.8 141.8 0 1 1-283.6 0 141.8 141.8 0 0 1 283.6 0zm-53.2 0c0 14.7 22.8 3 9.4 43a81 81 0 0 1-56.6 55c-40.2 12.7-26.7-9.4-41.4-9.4-14.6 0-1.1 22.1-41.3 9.4a80.2 80.2 0 0 1-56.6-56.6c-12.8-40.2 9.3-26.7 9.3-41.4s-22-1.1-9.3-41.3a80.2 80.2 0 0 1 56.6-56.6c40.2-12.8 26.7 9.3 41.3 9.3 14.7 0 1.2-22 41.4-9.3a80.3 80.3 0 0 1 56.6 56.6c12.7 40.2-9.4 26.6-9.4 41.3z",
    transform: "matrix(1.8992 0 0 1.8865 -662.5 -102.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M126.5 157.7c-20.2 0-1.9 67.6-9 51.7a126.5 126.5 0 0 1 0-103.4c7.1-16-11.2 51.7 9 51.7z",
    transform: "matrix(1.6618 0 0 1.7607 -603.6 -99.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M372 140a88 88 0 0 1-9.7 44.8c-8 13.7 9.8-44.8-8-44.8 17.7 0 1.7-58.6 8-44.8a107.7 107.7 0 0 1 9.8 44.8z",
    transform: "matrix(1.8992 0 0 2.0316 -662.5 -106.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M296.3 263a123.5 123.5 0 0 1-96.5 0c-14.9-6.2 48.2 9.8 48.2-7.9 0 17.7 63.1 1.7 48.3 8zM248 42.6c0-17.7-63-1.7-48.2-8a123 123 0 0 1 96.5 0c14.8 6.3-48.3-9.7-48.3 8z",
    transform: "matrix(1.8992 0 0 1.8865 -662.5 -102.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M276.6 287.7a142 142 0 0 1-57.1 0l-1.5 7a149 149 0 0 0 60 0l-1.4-7z",
    transform: "matrix(1.2929 -1.3819 -1.3912 -1.2842 -305.2 712)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M276.6 287.7a142 142 0 0 1-57.1 0l-1.5 7a149 149 0 0 0 60 0l-1.4-7z",
    transform: "matrix(1.2929 -1.3819 1.3912 1.2842 -719.6 329.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M267.7 308.5c-9.2 1.9-20.2 1-30 1-9.7 0-19.3-2.7-28.5-4.6l8.8-10.3a149.3 149.3 0 0 0 60 0l-10.3 14z",
    transform: "matrix(1.2929 -1.3819 1.3912 1.2842 -719.6 329.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M276.6 287.7a142 142 0 0 1-57.1 0l-1.5 7a149 149 0 0 0 60 0l-1.4-7z",
    transform: "matrix(1.3912 1.2842 -1.2929 1.3819 -343.8 -345.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.1,
    cy: 160.9,
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    rx: 18.4,
    ry: 20.1,
    transform: "matrix(1.2929 -1.3819 1.3912 1.2842 -285.5 314.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M267.6 281.5c-9.2 1.9-17.1 3-26.9 3s-23-.8-32.3-2.7l9.6 12.8a149.5 149.5 0 0 0 60 0l-10.4-13.1z",
    transform: "matrix(1.3912 1.2842 -1.2929 1.3819 -347 -315.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m174 271.8-.9 14.8-3.2 4.5 1-15 3-4.3zm156.5-6.2 3.6 4.2 1 13.6-2.9-3-1.7-14.8z",
    transform: "matrix(1.8992 0 0 1.8865 -662.5 -102.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.1,
    cy: 160.9,
    fill: "silver",
    stroke: "#000",
    strokeWidth: "1pt",
    rx: 18.4,
    ry: 20.1,
    transform: "matrix(1.2929 -1.3819 1.3912 1.2842 -733.9 329.9)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff133",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.6,
    d: "m301.2 396.9 17.7 17.7-17.7 17.7 8.8 8.8 17.7-17.7 35.5 35.5-17.7 17.7 8.8 8.8 17.7-17.7 17.8 17.7-53.2 53.2-35.4-35.4 17.7-17.8 8.9 8.9 8.8-8.9-35.4-35.4-8.9 8.9 8.9 8.8-17.7 17.7-17.7-17.7 8.8-8.8-8.8-8.9-35.5 35.4 8.9 8.9 8.8-8.9 17.8 17.8-17.8 17.7-8.8-8.9-8.9 8.9 35.5 35.4 8.8-8.9-8.8-8.8 17.7-17.7 35.4 35.4-53.1 53.1-17.8-17.7 17.8-17.7-9-8.8-17.6 17.7-35.5-35.5 17.8-17.7-8.9-8.8-17.7 17.7-17.7-17.7 124-124z",
    transform: "matrix(2.2946 0 0 2.2438 143.1 -1733.7)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M318.9 786.6V822l88.6 88.6v-70.8L389.8 822h-35.5L319 786.6z",
    transform: "matrix(1.1473 0 0 1.1219 346.4 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m230.4 698.8 70.4 70.4.8 35.2-71.2-71.3v-34.3z",
    transform: "matrix(1.1473 0 0 1.1219 346.3 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m301.2 804.3 35.4-35.4v-35.4l-35.4 35.4v35.4z",
    transform: "matrix(1.1473 0 0 1.1219 346.4 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m301.2 804.3 35.4-35.4v-35.4l-35.4 35.4v35.4z",
    transform: "matrix(1.1473 0 0 1.1219 244.7 -1387.9)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M248 644.9v35.4l17.8-17.7-17.8-17.7z",
    transform: "matrix(1.1473 0 0 1.1219 346.4 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M248 644.9v35.4l17.8-17.7-17.8-17.7z",
    transform: "matrix(1.1473 0 0 1.1219 448 -1189.1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m230.4 698.8 35.8 35.4v35.4l-35.8-36.5v-34.3z",
    transform: "matrix(1.1473 0 0 1.1219 284.9 -1349)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m301.2 804.3 35.4-35.4v-35.4l-35.4 35.4v35.4z",
    transform: "matrix(1.1473 0 0 1.1219 448 -1507.1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m301.2 804.3 35.4-35.4v-35.4l-35.4 35.4v35.4z",
    transform: "matrix(1.1473 0 0 1.1219 366.7 -1427.6)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m283.5 822 53.1-53.1v-35.4l-70.9 70.8 17.8 17.8z",
    transform: "matrix(1.1473 0 0 1.1219 366.7 -1546.9)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M248 644.9v35.4l17.8-17.7-17.8-17.7z",
    transform: "matrix(1.1473 0 0 1.1219 468.3 -1447.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M301.2 804.3 265.8 769v-35.4l35.4 35.4v35.4z",
    transform: "matrix(1.1473 0 0 1.1219 448 -1507.1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m389.8 822-53.2-53v-35.4l70.9 70.8-17.7 17.8z",
    transform: "matrix(1.1473 0 0 1.1219 448 -1546.9)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m230.4 698 70.9 71h35.4l17.7 17.6v70.9l-124-124.4v-35z",
    transform: "matrix(1.1473 0 0 1.1219 569.8 -1387.9)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m354.3 822 106.3-106.3h35.5L389.8 822h-35.5zm53.2 17.8 106.3-106.3-17.7-17.7L389.8 822l17.7 17.7z",
    transform: "matrix(1.1473 0 0 1.1219 346.4 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M407.5 839.8v70.8l106.3-106.3v-70.8L407.5 839.8z",
    transform: "matrix(1.1473 0 0 1.1219 346.4 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m354.3 822 106.3-106.3h35.5L389.8 822h-35.5zm53.2 17.8 106.3-106.3-17.7-17.7L389.8 822l17.7 17.7z",
    transform: "matrix(1.1473 0 0 1.1219 509 -1447.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M407.5 839.8v70.8l106.3-106.3v-70.8L407.5 839.8z",
    transform: "matrix(1.1473 0 0 1.1219 509 -1447.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m318.9 786.6 17.7-17.7v-35.4l-35.4 35.4 17.7 17.7z",
    transform: "matrix(1.1473 0 0 1.1219 590.3 -1527)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m318.9 786.6 17.7-17.7v-35.4l-35.4 35.4 17.7 17.7z",
    transform: "matrix(1.1473 0 0 1.1219 488.6 -1626.4)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M265.8 768.9v-35.4l17.7 17.7-17.7 17.7z",
    transform: "matrix(1.1473 0 0 1.1219 448 -1348.1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M301.2 804.3 265.8 769l17.7-17.7 17.7 17.7v35.4z",
    transform: "matrix(1.1473 0 0 1.1219 366.7 -1427.6)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "m301.2 804.3-17.7-17.7 17.7-17.7v35.4z",
    transform: "matrix(1.1473 0 0 1.1219 488.6 -1586.6)"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#b00",
    stroke: "#000",
    strokeWidth: 20
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.9 291.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.9 289.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.9 287.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 377 285.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.8 299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.8 297.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.8 295.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.9 293.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 377 275.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 377 274.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 377 272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 377.1 270.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 377 283.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 377 281.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 377 279.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 377 278)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.6 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.6 320.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.6 318.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.6 316.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.5 329.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.5 328)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.5 325.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.5 324.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.7 306.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.7 305)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.8 302.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.8 301.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.6 314.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.7 312.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.7 310.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.7 308.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.2 352.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.3 351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.3 349)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.3 347.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.2 358.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.2 356.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.2 354.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.4 337.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.4 335.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.4 333.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.5 331.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.3 345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.3 343.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.4 341.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.4 339.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 376 372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376 370.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 376 368.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.1 366.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 376 376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376 374.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.1 364.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.1 362.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.1 360.6)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#b00",
    stroke: "#000",
    strokeWidth: 20
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.5 291.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.5 289.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.5 287.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.5 286)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.5 299.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.5 297.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.5 295.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.5 293.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.4 276.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.5 274.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.4 272.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.4 270.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.5 283.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.5 282.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.5 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.5 278.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.6 322.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.6 320.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.6 318.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.6 316.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.6 330)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.6 328.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.6 326.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.6 324.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.6 306.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.6 305.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.5 303)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.6 301.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.6 314.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.6 312.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.6 310.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.6 309)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.7 353)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.7 351.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.7 349.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.7 347.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.7 359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.7 356.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.7 355.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.6 337.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.7 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.6 333.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.6 332.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.7 345.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.7 343.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.7 341.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.7 339.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.8 372.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.8 370.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.7 368.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.8 366.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.8 378.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.8 376.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.8 374.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.7 364.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.7 363)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.7 360.8)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#b00",
    stroke: "#000",
    strokeWidth: 14.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.0162 .00404 .00232 .0128 390 279.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.0045 .013 -.01229 .00849 386.7 276.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01181 .00968 -.00565 .01213 388 278.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00986 .01097 -.01604 -.00222 386.4 273.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00934 .01104 -.01615 -.0021 388.6 273.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01037 .01067 -.01593 -.0027 377 273.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00985 .01076 -.01604 -.00257 379.1 273.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01037 .01067 -.01593 -.0027 381.8 273.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00934 .01104 -.01615 -.0021 383.7 273.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01037 .01067 -.01593 -.0027 373.9 272.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01138 .00976 -.01555 -.00406 375.4 272.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01504 .00625 -.01305 -.00773 374.5 271.2)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#b00",
    stroke: "#000",
    strokeWidth: 14.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01307 -.00787 -.01355 .0062 420.7 360.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01263 -.00807 -.0137 .00611 422.6 359.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01307 -.00787 -.01355 .0062 425 359.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01263 -.00807 -.0137 .00611 427 358.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01559 .00255 -.00363 .01263 441.4 352.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0103 .01036 .00644 .01175 443.3 347)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0157 .00296 -.00345 .0126 442.4 350.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01221 -.00878 -.01414 .0052 411.6 362.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01175 -.00895 -.01428 .0051 413.6 361.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0134 -.00747 -.01328 .0066 416.7 361.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01125 -.00939 -.01454 .00455 417.5 360.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01307 -.00787 -.01355 .0062 429.4 358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01263 -.00807 -.0137 .00611 431.4 357.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00984 -.01067 -.0151 .0027 382.8 363.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00934 -.01075 -.01521 .00257 384.9 363.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00984 -.01067 -.0151 .0027 387.4 363.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00934 -.01075 -.01521 .00257 389.5 363.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00984 -.01067 -.0151 .0027 373.7 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00934 -.01075 -.01521 .00257 375.7 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00984 -.01067 -.0151 .0027 378.3 363.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00934 -.01075 -.01521 .00257 380.3 363.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01117 -.0097 -.01466 .00406 401.9 363.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01105 -.00955 -.01463 .00433 404.1 363.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01153 -.0094 -.0145 .00444 406.7 362.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01175 -.00895 -.01428 .0051 409.1 362.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00984 -.01067 -.0151 .0027 392 363.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01015 -.01023 -.01499 .00338 394.4 363.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01123 -.00966 -.01464 .00412 397.3 363.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00994 -.01037 -.01505 .00317 398.9 363.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0074 -.01197 -.01544 .00039 345.1 362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00689 -.01198 -.01552 .00025 347.1 362.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00882 -.01127 -.0153 .00171 350.2 363)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00832 -.01133 -.0154 .00158 352.3 363)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00689 -.01198 -.01552 .00025 338 361.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0074 -.01197 -.01544 .00039 340.6 361.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00689 -.01198 -.01552 .00025 342.6 361.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00882 -.01127 -.0153 .00171 364 363.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00832 -.01133 -.0154 .00158 366 363.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00984 -.01067 -.0151 .0027 369 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00934 -.01075 -.01521 .00257 371.1 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00882 -.01127 -.0153 .00171 354.8 363.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00832 -.01133 -.0154 .00158 356.8 363.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00882 -.01127 -.0153 .00171 359.4 363.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00832 -.01133 -.0154 .00158 361.4 363.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01592 -.00203 .00451 -.01237 330 344.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01266 -.00804 -.00338 -.01268 327.5 348.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.0085 -.01144 -.0083 -.0109 327.4 351.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.00338 -.013 -.01242 -.0078 328 355)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01585 .00085 .00735 -.01145 335 339.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01609 .00047 .00716 -.01145 333.4 341)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01577 -.00162 .0047 -.01239 331.2 342.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0009 -.01346 -.01428 -.00493 329.9 357.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.00393 -.01288 -.01527 -.00232 332.5 359.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.0074 -.01197 -.01544 .00039 336 360.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01563 -.00324 -.00984 .00997 434.9 356.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01507 -.0042 -.0106 .0095 435 356.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01583 -.00244 -.0091 .01045 439.4 354.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(-.01496 -.00447 -.01083 .0093 436.6 355.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01467 -.00556 .01183 .00831 430.2 346.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01428 -.00583 .012 .00825 428.5 345.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01514 -.0046 .01102 .00905 425.6 344.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01428 -.00583 .012 .00825 436.5 349.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01467 -.00556 .01183 .00831 434.2 348.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01428 -.00583 .012 .00825 432.5 347.7)"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    transform: "matrix(.07228 0 0 .0858 364.6 299.2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    d: "M212.6-1995v53.2h-53.1v35.5h53.1v106.3H248v-106.3h53.2v-35.5H248v-53.1h-35.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.2,
    cy: -1813.5,
    fill: "#fff133",
    stroke: "#000",
    rx: 62,
    ry: 57.3,
    transform: "matrix(.57143 0 0 .61816 93.6 -679)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    d: "M602.4-1119.4c0 68.5-10.5 145.7-29.3 205-120-26.4-268-39.7-339-39.7-87.6 0-246.2 13.3-345.3 26.5a630.8 630.8 0 0 1-30.5-191.8c0-273.8 105.2-390.2 367.5-496 233.3 105.8 376.6 222.2 376.6 496z",
    transform: "matrix(1.0576 0 0 1.3394 -5.8 363.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    d: "M567-657.3c0-44-150.9-79.7-336.7-79.7s-336.6 35.7-336.6 79.7v26.6c0-44 150.8-70.9 336.6-70.9S567-657 567-613v-44.3z",
    transform: "matrix(1.1715 0 0 .74463 -32.8 -634.9)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff133",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m230.3-825.6-53.1 53.2 35.4 35.4-17.7 17.7-35.5-35.4-53.1 53.1 53.1 53.2L195-684l17.7 17.8v53.1H248v-53.1l17.7-17.8 35.5 35.5 53.1-53.2-53.1-53.1-35.4 35.4L248-737l35.5-35.5-53.2-53.1z",
    transform: "matrix(1.1725 0 0 .74463 -33 -766.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221-825.6-8.4 53.2v35.4l-17.7 17.7v-35.4l-17.7 53.1 17.7 53.2V-684l17.7 17.8v53.1h17.7v-53.1L248-684v35.5l17.8-53.2-17.8-53.1v35.4L230.3-737v-35.4l-9.3-53.2z",
    transform: "matrix(1.13516 -.18643 .29356 .72091 -190 -703.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221-825.6-8.4 53.2v35.4l-17.7 17.7v-35.4l-17.7 53.1 17.7 53.2V-684l17.7 17.8v53.1h17.7v-53.1L248-684v35.5l17.8-53.2-17.8-53.1v35.4L230.3-737v-35.4l-9.3-53.2z",
    transform: "matrix(1.1416 .16986 -.26746 .725 182.2 -778.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.7-1020.5a38.1 38.1 0 0 1 35.5-35.4c17.7 0 35.4 17.7 35.4 35.4s-17.7 35.4-17.7 35.4l70.8 70.9h-35.4l-53.1-53.1-53.2 53.1H88.6l70.9-70.9s-17.8-17.7-17.8-35.4z",
    transform: "matrix(.92597 -.09509 .18717 .73508 28.8 -521.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.7-1020.5a38.1 38.1 0 0 1 35.5-35.4c17.7 0 35.4 17.7 35.4 35.4s-17.7 35.4-17.7 35.4l70.8 70.9h-35.4l-53.1-53.1-53.2 53.1H88.6l70.9-70.9s-17.8-17.7-17.8-35.4z",
    transform: "matrix(.92699 .091 -.17909 .7359 124.8 -554)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567-657.3c0-44-150.9-79.7-336.7-79.7s-336.6 35.7-336.6 79.7v26.6c0-44 150.8-70.9 336.6-70.9S567-657 567-613v-44.3z",
    transform: "matrix(1.1725 0 0 .74463 -33 -674.5)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    d: "M567-657.3c0-44-150.9-79.7-336.7-79.7s-336.6 35.7-336.6 79.7v26.6c0-44 150.8-70.9 336.6-70.9S567-657 567-613v-44.3z",
    transform: "matrix(1.0735 0 0 .74463 -9.3 -386.9)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff133",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m230.3-825.6-53.1 53.2 35.4 35.4-17.7 17.7-35.5-35.4-53.1 53.1 53.1 53.2L195-684l17.7 17.8v53.1H248v-53.1l17.7-17.8 35.5 35.5 53.1-53.2-53.1-53.1-35.4 35.4L248-737l35.5-35.5-53.2-53.1z",
    transform: "matrix(1.1042 0 0 .74463 -12.9 -518.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221-825.6-8.4 53.2v35.4l-17.7 17.7v-35.4l-17.7 53.1 17.7 53.2V-684l17.7 17.8v53.1h17.7v-53.1L248-684v35.5l17.8-53.2-17.8-53.1v35.4L230.3-737v-35.4l-9.3-53.2z",
    transform: "matrix(1.06903 -.18643 .27645 .72092 -160.7 -455.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221-825.6-8.4 53.2v35.4l-17.7 17.7v-35.4l-17.7 53.1 17.7 53.2V-684l17.7 17.8v53.1h17.7v-53.1L248-684v35.5l17.8-53.2-17.8-53.1v35.4L230.3-737v-35.4l-9.3-53.2z",
    transform: "matrix(1.0751 .16986 -.25188 .725 189.8 -530.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.7-1020.5a38.1 38.1 0 0 1 35.5-35.4c17.7 0 35.4 17.7 35.4 35.4s-17.7 35.4-17.7 35.4l70.8 70.9h-35.4l-53.1-53.1-53.2 53.1H88.6l70.9-70.9s-17.8-17.7-17.8-35.4z",
    transform: "matrix(.87203 -.09509 .17626 .73508 45.4 -273.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.7-1020.5a38.1 38.1 0 0 1 35.5-35.4c17.7 0 35.4 17.7 35.4 35.4s-17.7 35.4-17.7 35.4l70.8 70.9h-35.4l-53.1-53.1-53.2 53.1H88.6l70.9-70.9s-17.8-17.7-17.8-35.4z",
    transform: "matrix(.873 .091 -.16866 .7359 135.8 -306)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567-657.3c0-44-150.9-79.7-336.7-79.7s-336.6 35.7-336.6 79.7v26.6c0-44 150.8-70.9 336.6-70.9S567-657 567-613v-44.3z",
    transform: "matrix(1.1042 0 0 .74463 -12.9 -426.4)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    d: "M567-657.3c0-44-150.9-79.7-336.7-79.7s-336.6 35.7-336.6 79.7v26.6c0-44 150.8-70.9 336.6-70.9S567-657 567-613v-44.3z",
    transform: "matrix(1.105 0 0 .74463 -16.1 -865.2)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff133",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m230.3-825.6-53.1 53.2 35.4 35.4-17.7 17.7-35.5-35.4-53.1 53.1 53.1 53.2L195-684l17.7 17.8v53.1H248v-53.1l17.7-17.8 35.5 35.5 53.1-53.2-53.1-53.1-35.4 35.4L248-737l35.5-35.5-53.2-53.1z",
    transform: "matrix(1.0799 0 0 .70238 -6.2 -1031.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221-825.6-8.4 53.2v35.4l-17.7 17.7v-35.4l-17.7 53.1 17.7 53.2V-684l17.7 17.8v53.1h17.7v-53.1L248-684v35.5l17.8-53.2-17.8-53.1v35.4L230.3-737v-35.4l-9.3-53.2z",
    transform: "matrix(1.0455 -.17585 .27037 .68 -150.8 -971.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221-825.6-8.4 53.2v35.4l-17.7 17.7v-35.4l-17.7 53.1 17.7 53.2V-684l17.7 17.8v53.1h17.7v-53.1L248-684v35.5l17.8-53.2-17.8-53.1v35.4L230.3-737v-35.4l-9.3-53.2z",
    transform: "matrix(1.05143 .16022 -.24634 .68386 192.1 -1042.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.7-1020.5a38.1 38.1 0 0 1 35.5-35.4c17.7 0 35.4 17.7 35.4 35.4s-17.7 35.4-17.7 35.4l70.8 70.9h-35.4l-53.1-53.1-53.2 53.1H88.6l70.9-70.9s-17.8-17.7-17.8-35.4z",
    transform: "matrix(.85284 -.0897 .17238 .69338 50.8 -800.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.7-1020.5a38.1 38.1 0 0 1 35.5-35.4c17.7 0 35.4 17.7 35.4 35.4s-17.7 35.4-17.7 35.4l70.8 70.9h-35.4l-53.1-53.1-53.2 53.1H88.6l70.9-70.9s-17.8-17.7-17.8-35.4z",
    transform: "matrix(.85378 .08583 -.16494 .69414 139.3 -830.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567-657.3c0-44-150.9-79.7-336.7-79.7s-336.6 35.7-336.6 79.7v26.6c0-44 150.8-70.9 336.6-70.9S567-657 567-613v-44.3z",
    transform: "matrix(1.0799 0 0 .70238 -6.2 -944.2)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 234.1,
    cy: -822.1,
    fill: "#b90000",
    rx: 375.9,
    ry: 120.5,
    transform: "matrix(.96627 0 0 .41385 13 -517.5)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m513.8-790.2 35.4-17.7 35.4 17.7s-73.3 35.5-73.3 159.5c0 88.6 125.2 106.3 125.2 212.6 0 45.6-34.1 88.6-69.6 88.6s-88.6-17.7-141.7-70.9c35.4 17.7 76 37.3 106.3 36 19.6-.3 55-17.7 55-53 0-71-122.8-107-122.8-213.3 0-124 50-159.4 50-159.4z",
    transform: "matrix(.21542 0 0 .17871 313.9 342.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b00",
    stroke: "#000",
    strokeWidth: 20,
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01859 -.00133 .0085 .02009 379 385.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m520.3-790.2 46.6-17.7 10 17.7s-70.6 35.5-70.6 159.5c0 88.6 125.9 106.3 125.9 212.6 0 45.6-26.7 87.4-65.3 88.6-73.4 2.3-90.4-24-141.7-70.9 43.1 32.3 105 46.8 129 34.2 29.4-15.4 35-36 35-53.8 0-70.9-120.9-104.4-120.9-210.7 0-124 52-159.4 52-159.4z",
    transform: "matrix(.21542 0 0 .17871 313.9 342.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M513.3-789.7c7-2.4 36-18.2 71.3 17.3 17.8 17.7 17.8 53.1 17.8 70.8l53.1-53.1s-29-86.9-107.6-53.6a334.8 334.8 0 0 0-34.5 18.6z",
    transform: "matrix(.21542 0 0 .17871 313.9 342.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "M523.8-796c8.8-2.8 36.7-6.3 64.6 18.6 17.7 17.7 19 42.9 19 60.6l40.6-38c3.4-3.1-24.8-81.2-99.2-54a154 154 0 0 0-25 12.9z",
    transform: "matrix(.21542 0 0 .17871 313.9 342.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m344.5-596.3 9.2 22.1s1.5-9.7 8.5-11.5l7-1.7s27 49.3 32.3 58.1c5.3 8.8-3.6 16.8-1.8 16.8s26.5-11.5 26.5-11.5-10.6.9-15-6.2-34.8-60-34.8-60 6.1-2.6 11.4-5.2c5.3-2.7 10.6 8 10.6 8L385.2-614s0 8.9-4.4 10.6c-4.4 1.8-8 3.6-8 3.6s-3.5-6.2-8-13.3c-4.4-7 4.5-14.1 4.5-14.1l-23 11.5s8 4.4 10.6 8.8l5.3 8.8s-3.2 1.8-8.2 3.5c-3.6 1.9-7.7 0-9.5-1.7z",
    transform: "matrix(.17534 -.01853 .05985 .15541 398.7 344.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    stroke: "#000",
    strokeWidth: "1pt",
    d: "m344.5-596.3 9.2 22.1s1.5-9.7 8.5-11.5l7-1.7s27 49.3 32.3 58.1c5.3 8.8-3.6 16.8-1.8 16.8s26.5-11.5 26.5-11.5-10.6.9-15-6.2-34.8-60-34.8-60 6.1-2.6 11.4-5.2c5.3-2.7 10.6 8 10.6 8L385.2-614s0 8.9-4.4 10.6c-4.4 1.8-8 3.6-8 3.6s-3.5-6.2-8-13.3c-4.4-7 4.5-14.1 4.5-14.1l-23 11.5s8 4.4 10.6 8.8l5.3 8.8s-3.2 1.8-8.2 3.5c-3.6 1.9-7.7 0-9.5-1.7z",
    transform: "matrix(-.15954 .02165 -.00278 -.11904 505.5 127.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b00",
    stroke: "#000",
    strokeWidth: 20,
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.01859 -.00133 .0085 .02009 382 385)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b00",
    stroke: "#000",
    strokeWidth: 20,
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.0313 -.00133 .01432 .02009 377.4 387.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b00",
    stroke: "#000",
    strokeWidth: 20,
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.0313 -.00133 .01432 .02009 380.4 387.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b00",
    stroke: "#000",
    strokeWidth: 20,
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.0388 -.00133 .01775 .02009 376.2 390.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b00",
    stroke: "#000",
    strokeWidth: 20,
    d: "M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z",
    transform: "matrix(.0388 -.00133 .01775 .02009 379.9 390.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    d: "M0 0h256v512H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVa);
export default __webpack_public_path__ + "static/media/va.e36b45f735b377297b2c703d03bfb488.svg";
export { ForwardRef as ReactComponent };